import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Plan } from "../models/plan";

@Injectable({
    providedIn: "root"
})
export class PlanEditService {

    private currentPlan = new BehaviorSubject<Plan>(null);
    plan$ = this.currentPlan.asObservable();

    private isEditing = false;
    private isDirty = false;

    private editorStartStep = 1;
    private editingPlanYear: number;

    updatePlan(plan: Plan){
        this.currentPlan.next(plan);
    }

    getIsEditing(): boolean {
        return this.isEditing;
    }

    setIsEditing(isEditing: boolean, editorStartStep: number, year: number) {
        this.isEditing = isEditing;
        this.editorStartStep = editorStartStep;
        this.editingPlanYear = year;
    }

    getIsDirty() : boolean {
        return this.isDirty;
    }

    setIsDirty(isDirty: boolean) {
        this.isDirty = isDirty;
    }

    getEditorStartStep(){
        return this.editorStartStep;
    }

    getEditingPlanYear() {
        return this.editingPlanYear;
    }

    clear() {
        this.isDirty = false;
        this.isEditing = false;
        this.editorStartStep = 1;
    }
}